import AppStorage from '@/utils/helpers';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type CategoryState = {
  category: string[];
  menu: any[];
  outlet: any;
  reload: boolean;
  openAddLocationModal: boolean;
};

const loadOutletFromAppStorage = () => {
  if (typeof window !== 'undefined') {
    const outletJSON = AppStorage.get('outlet');
    if (!outletJSON || outletJSON === 'undefined') {
      return null;
    }
    return JSON.parse(outletJSON);
  }
};

const initialState: CategoryState = {
  category: [],
  menu: [],
  outlet: loadOutletFromAppStorage(),
  reload: false,
  openAddLocationModal: false,
};

const categorySlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    addToCategory: (state, { payload }: PayloadAction<string[]>) => {
      state.category = payload;
    },
    addToMenu: (state, { payload }: PayloadAction<any[]>) => {
      state.menu = payload;
    },
    addToOutlet: (state, { payload }: PayloadAction<any>) => {
      state.outlet = payload;
      AppStorage.save('outlet', JSON.stringify(payload));
    },
    reloadMenu: (state, { payload }: PayloadAction<boolean>) => {
      state.reload = payload;
    },
    setOpenAddLocationModal: (state, { payload }: PayloadAction<boolean>) => {
      state.openAddLocationModal = payload;
    },
  },
});

const { actions, reducer: CategoryReducer } = categorySlice;

export const {
  addToCategory,
  addToMenu,
  addToOutlet,
  reloadMenu,
  setOpenAddLocationModal,
} = actions;
export default CategoryReducer;
